import PageTitle from "../../components/PagesComponents/PageTitleSection/PageTitle";

const Photos = () => {
  return (
    <>
    <PageTitle pagetitle="OUR PHOTOS" /> 
    
    <div className=''>
      
      
    </div></>
  )
}

export default Photos